import { ErrorMessage, useFormikContext } from 'formik'
import { useTranslation } from 'context/translation'
import DropdownIcon from 'icon/dropdown'
import React from 'react'

export default function Select({
  name,
  placeholder,
  label,
  options = [],
  onSelect,
  value,
  className, // Add className prop here
  required,
}) {
  const formik = useFormikContext()
  const { t } = useTranslation()
  const inputProps = name ? formik.getFieldProps(name) : {}
  const selectedValue = value !== undefined ? value : inputProps.value

  const handleChange = (event) => {
    const selectedOption = options.find(
      (option) => String(option.value) === event.target.value
    )
    const nextValue = selectedOption ? selectedOption.value : event.target.value

    if (name) formik.setFieldValue(name, nextValue)
    if (onSelect) onSelect(event)
  }

  return (
    <div>
      {label ? (
        <label
          htmlFor={name}
          className='block mb-2 text-sm font-medium text-gray-900'
        >
          {label || ''}
          {required ? ' *' : ''}
        </label>
      ) : null}
      <div className='relative w-full'>
        <div class='absolute end-2 top-4'>
          <DropdownIcon />
        </div>
        <select
          placeholder={placeholder || ''}
          {...inputProps}
          value={selectedValue ?? ''}
          onChange={handleChange}
          className={`w-full truncate pe-5 p-2.5 text-sm text-gray-500 bg-white border rounded-md shadow-sm outline-none appearance-none focus:border-indigo-600 ${className}`} // Add className here

          // className='w-full truncate pe-5  p-2.5 text-sm text-gray-500 bg-white border rounded-md shadow-sm outline-none appearance-none focus:border-indigo-600'
        >
          <option disabled selected value={''}>
            {' '}
            {placeholder || t('Select option')}
          </option>
          {options?.map((option) => (
            <option disabled={option.disabled} value={option.value}>
              {/* Option labels are defined in module-level arrays, where t() cannot be
                  called — so they are translated here at render. t() returns the key
                  unchanged when there is no entry, so an already-translated or custom
                  label passes through untouched. */}
              {t(option.label)}
            </option>
          ))}
        </select>
        {name && (
          <ErrorMessage
            name={name || ''}
            component={'div'}
            className='text-xs text-red-500 font-light mt-1'
          />
        )}
      </div>
    </div>
  )
}
